import apiServices from "@/services/yungol-services";

export async function analyzeUpload({ url, proceso, tipo }) {
  const response = await apiServices.post("/analizarcargaclima", {
    url,
    proceso,
    tipo
  });
  return response.data;
}

export async function saveBatch(path, { url, proceso, dependenciasACrear }) {
  const response = await apiServices.post(path, {
    url,
    proceso,
    dependenciasACrear
  });
  return response.data;
}



// WEBPACK FOOTER //
// ./src/components/climan/upload/api.js